Namespace 'Monitoring.Models.SocialContents.LinkedIn'


class Monitoring.Models.SocialContents.LinkedIn.LinkedInContent

  constructor: (linkedInAuthor) ->
    @linkedInAuthor = linkedInAuthor

  getJson: ->
    throw new Error('not implemented')

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    true

  getGroupType: ->
    'linkedin'

  getType: ->
    'linkedin'

  getAuthor: ->
    @linkedInAuthor

  getAuthorId: ->
    @linkedInAuthor.getId()

  getAuthorName: ->
    @linkedInAuthor.getName()

  getAuthorUsername: ->
    @linkedInAuthor.getUsername()

  getAvatar: ->
    @linkedInAuthor.getProfilePictureUrl()

  getMainText: ->
    throw new Error('not implemented')

  getCreatedAt: ->
    throw new Error('not implemented')

  getParentId: ->
    throw new Error('not implemented')

  getContentId: ->
    throw new Error('not implemented')

  isBrandContent: ->
    throw new Error('not implemented')

  getSubType: ->
    throw new Error('not implemented')
